import api from '../../../../api.js'
import {handleResponseErrors} from '../../../services/processServerErrors.js'
import {generate} from '../../../routes.js'

export default async function (values) {
  return api.users.add(values)
    .then(
      window.gtag(
        'event',
        'conversion',
        {'send_to': 'AW-762017811/Iq82CP6JlKwBEJPwresC', 'event_callback': generate({name: 'homepage'})}
      )
    )
    .catch(handleResponseErrors)
}